module.exports = __webpack_public_path__ + "img/Ma.Maritime.Breakwaters.Rubble-mounded-9m.Rock.2690c016.png";